/*
 * Autoplay Videos
 *
 * Manages all <video autoplay> on the page.
 * Only one plays at a time — the one visible in viewport.
 * When a deferred-media gallery video steals playback, restarts the managed video after it ends.
 */

document.addEventListener('DOMContentLoaded', () => {
  const videos = [...document.querySelectorAll('video[autoplay]')];
  if (!videos.length) return;

  const pauseOthers = (active) => {
    videos.forEach((v) => {
      if (v !== active) v.pause();
    });
  };

  videos.forEach((video) => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            pauseOthers(video);
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.3 }
    );
    io.observe(video);
  });

  // Deferred-media support (PDP gallery videos)
  const deferredMedias = document.querySelectorAll('deferred-media');
  if (deferredMedias.length) {
    const restart = () => {
      const visible = videos.find((v) => {
        const rect = v.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      });
      if (visible) {
        setTimeout(() => {
          pauseOthers(visible);
          visible.play().catch(() => {});
        }, 300);
      }
    };

    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.tagName === 'VIDEO') {
            node.addEventListener('pause', restart);
            node.addEventListener('ended', restart);
          }
        });
      });
    });

    deferredMedias.forEach((dm) => {
      mo.observe(dm, { childList: true, subtree: true });
    });
  }
});
